import { FunctionComponent, useRef } from "react";
import { useDispatch } from "react-redux";

import { ViewList } from "@material-ui/icons";
import { useChartsContext } from "contexts/ChartContext";
import { updateChartByPath } from "store/features";
import styled from "styled-components/macro";

import { useChartEntities } from "hooks/charts";

import { ToolbarButton } from "components/base";

import { ChartSelector } from "./ChartSelector/ChartSelector";
import { ProductSelector } from "./ProductSelector/ProductSelector";

const ChartHeader: FunctionComponent = () => {
  const chartSelectorCloseRef = useRef<(() => void) | null>(null);
  const productSelectorCloseRef = useRef<(() => void) | null>(null);

  const dispatch = useDispatch();
  const { id } = useChartsContext();
  const { dataTable } = useChartEntities(id);
  const isDataTableActive = dataTable?.active;
  const isDataTableEnabled = dataTable?.enabled;
  const dataTableTooltipText = dataTable?.properties?.tooltipText;
  const dataTableOverflowLabel = dataTable?.properties?.overflowLabel;

  const onToggleDataTable = (visible: boolean) => {
    dispatch(
      updateChartByPath({
        id,
        path: `features.datatable.active`,
        value: visible
      })
    );
  };
  return (
    <Wrapper>
      {isDataTableEnabled && (
        <ToolbarButton
          data-testid="chart-data-table-toggle"
          style={{ marginLeft: "4px", marginRight: "4px" }}
          active={isDataTableActive}
          icon={<ViewList fontSize="large" />}
          tooltipText={dataTableTooltipText}
          overflowLabel={dataTableOverflowLabel as string}
          onToggle={onToggleDataTable}
          disabled={false}
        />
      )}
      <Divider />

      <ChartSelector
        registerCloseMenu={(fn) => {
          chartSelectorCloseRef.current = fn;
        }}
        onMenuOpened={() => productSelectorCloseRef.current?.()}
      />
      <ProductSelector
        registerCloseMenu={(fn) => {
          productSelectorCloseRef.current = fn;
        }}
        onMenuOpened={() => chartSelectorCloseRef.current?.()}
      />
    </Wrapper>
  );
};

export default ChartHeader;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 36px;
`;

const Divider = styled.div`
  width: 1px;
  height: var(--chart-toolbar-height);
  background-color: #d9e1e2;
`;
